import { ref } from '@vue/composition-api'
import { kpEndpoint, kpRequest } from '@/axios'
import { apiToastError } from '@/@core/utils/toast'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'

export function useAnalytics() {
  const makekeDashboardUrl = ref('')
  const isLoadedAnalyticsUrl = ref(false)

  async function getAnalyticsUrl() {
    try {
      const response = await kpRequest({
        ...kpEndpoint.integrations.makeke,
      })

      makekeDashboardUrl.value = response?.data?.data?.makekeUrl
      isLoadedAnalyticsUrl.value = true
    } catch (error) {
      apiToastError(error)
    }
  }

  // Fires the "clicked analytics icon" + "opened analytics page" events.
  // V2Analytics calls this from setup(). Previously this function was
  // destructured but never defined, which threw a TypeError and broke the
  // entire page setup so the iframe never rendered.
  function trackClicksAnalytics() {
    analytics.track(constants.TRACKS.PAGES.BRAND_CLICKS_ANALYTICS)
    analytics.track(constants.TRACKS.PAGES.BRAND_OPENS_ANALYTICS_PAGE)
  }

  // Fires when the user navigates away from the analytics page.
  function trackExitAnalytics() {
    analytics.track(constants.TRACKS.PAGES.BRAND_EXITS_ANALYTICS_PAGE)
  }

  return {
    makekeDashboardUrl,
    isLoadedAnalyticsUrl,
    getAnalyticsUrl,
    trackClicksAnalytics,
    trackExitAnalytics,
  }
}
